import React, { useState } from 'react'
import { Link } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import Loading from '../components/util/Loading'
import { logoutAmpparit, toggleOverlay } from './userActions'
import { logoutAlmaTunnus } from './almalogin/almaUserActions'
import '../styles/login-overlay.pcss'
import { selectUserEmail } from '../selectors/userSelector'


const LoginOverlay = () => {
  const [logoutInProgress, setLogoutInProgress] = useState(false)
  const email = useSelector(selectUserEmail)
  const dispatch = useDispatch()

  const handleOverlayClose = () => {
    dispatch(toggleOverlay(false))
  }

  const handleLogout = async () => {
    if (logoutInProgress) return
    setLogoutInProgress(true)
    await dispatch(logoutAmpparit())
    dispatch(logoutAlmaTunnus())
  }

  const emailText = logoutInProgress ? 'Kirjataan ulos, sivu päivittyy ...' : email

  return (
    <div className='login-overlay'>
      <button type='button' className='login-overlay__close' onClick={ handleOverlayClose }>
        <span className='fa fa-times' />
        <span className='close-text'>Sulje</span>
      </button>

      <div className='login-overlay__content'>
        <h2>Käyttäjäprofiili</h2>
        <div className='login-overlay__info-text'>Olet kirjautuneena Alma-tunnuksella:</div>
        <div className='login-overlay__info-email'>{ emailText }</div>
        <Link className='button button_large' to='/asetukset/yleiset' onClick={ handleOverlayClose }>
          <span className='button-icon fa fa-user-circle'> </span>
          <span className='button-text'>Asetukset</span>
        </Link>
        <button type='button' className='button button_large' onClick={ handleLogout }>
          <Loading loading={ logoutInProgress }>
            <span className='button-icon fa fa-power-off'> </span>
            <span className='button-text'>Kirjaudu ulos</span>
          </Loading>
        </button>
      </div>
    </div>
  )
}

export default LoginOverlay
